import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import Icon from 'components/Icon';
import styles from './SearchInput.module.scss';

const SearchInput = ({
  setFilteredList,
  searchQuery,
  handleChange,
  setSearchQuery,
  setIsFocused,
  isFocused,
}) => {
  const searchInput = useRef('');
  return (
    <>
      <form className={styles.searchInputWrapper}>
        <div className={styles.searchWrap}>
          <input
            onChange={e => {
              handleChange(e);
            }}
            className={styles.search}
            type="text"
            value={searchQuery}
            ref={searchInput}
            onFocus={() => setIsFocused(true)}
            onBlur={() => (!searchQuery ? setIsFocused(false) : null)}
            onKeyPress={e => (e.key === 'Enter' ? e.preventDefault() : null)}
          />
          {isFocused && (
            <div
              className={styles.closeWrap}
              onClick={() => {
                setIsFocused(false);
                setFilteredList([]);
                setSearchQuery('');
              }}
            >
              <Icon icon="clear-close" color="white" size="medium" />
            </div>
          )}
          {!isFocused && (
            <div className={styles.searchPlaceholder}>
              <>
                <div className={styles.searchMag}>
                  <Icon icon="search-icon" color="white" size="smallLarge" />
                </div>
                <span>Search All Providers</span>
              </>
            </div>
          )}
        </div>
      </form>
    </>
  );
};

export default SearchInput;

SearchInput.propTypes = {
  setFilteredList: PropTypes.func,
  searchQuery: PropTypes.func,
  handleChange: PropTypes.func,
  setSearchQuery: PropTypes.func,
  setIsFocused: PropTypes.func,
  isFocused: PropTypes.bool,
};
